var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidepanelarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 24,
    viewBox: "0 0 14 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5679 10.9393C13.1537 11.5251 13.1537 12.4749 12.5679 13.0607L3.02195 22.6066C2.43616 23.1924 1.48642 23.1924 0.90063 22.6066C0.314844 22.0208 0.314844 21.0711 0.90063 20.4853L9.38591 12L0.90063 3.51472C0.314844 2.92893 0.314844 1.97918 0.90063 1.3934C1.48642 0.80761 2.43616 0.80761 3.02195 1.3934L12.5679 10.9393ZM10 10.5H11.5072V13.5H10V10.5Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidepanelarrow);
export default __webpack_public_path__ + "static/media/sidepanelarrow.97c9b8a3e9a66c519c4ec0b7d5452d79.svg";
export { ForwardRef as ReactComponent };